import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { t } from "i18next";
import Select, { StylesConfig } from 'react-select';
import { formatDateWithDateAndMonthName, getPageSizeArray, getFilteredList, setMilestoneStatus, paginationStyles } from '../../../common/timeLiveFunction';
import CustomPagination from "../../../common/Pagination";
import moment from "moment";
import { Dropdown } from "react-bootstrap";
import clsx from "clsx";
import { ShowToast } from "../../../common/Toastr";
import Loader from '../../../common/Loader';
import { ShowSwalWithConfirmation } from "../../../common/SweetAlert";
import { setItemStatus, sortData, getValueFromResource } from '../../../common/timeLiveFunction';
import PageSizeSelect from "../../../common/PageSizeSelect";
import {
    getProjectMilestoneList, updateIsLoading, updateAccountProjectMilestoneStatus, updateMilestone, deleteAccountProjectMilestone, updateIsCanvasFrom
} from "../MilestoneSlice";

const initialSortValues = {
    sortOrder: 'asc',
    sortColumn: 'MilestoneDescription',
    columnList: []
}

const MilestoneList = (props: any) => {
    const { AccountProjectId, IsEditMilestone, IsDeleteMilestone } = props;
    const dispatch = useAppDispatch();
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const { milestoneList, isLoading, isReload } = useAppSelector((state) => state.milestone);
    const { cultureInfoName, maxMenuHeight } = useAppSelector((state) => state.globalState);
    const [clientSideSorting, setClientSideSorting] = useState<any | ''>(initialSortValues);
    // const [hoveredColumn, setHoveredColumn] = useState(null);

    useEffect(() => {
        dispatch(getProjectMilestoneList(AccountProjectId));
    }, [isReload]);

    const onHandleSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
        setCurrentPage(1);
    }

    const onHandlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        setPageSize(Number(value));
        setCurrentPage(1);
    }

    const filteredData: any = getFilteredList(milestoneList, searchTerm);
    // filteredData.sort((a: any, b: any) => {
    //     const nameA = a[clientSideSorting.sortColumn] != null ? clientSideSorting.sortColumn === 'IsDisabled' ? a[clientSideSorting.sortColumn] : a[clientSideSorting.sortColumn].toLowerCase() : "";
    //     const nameB = b[clientSideSorting.sortColumn] != null ? clientSideSorting.sortColumn === 'IsDisabled' ? b[clientSideSorting.sortColumn] : b[clientSideSorting.sortColumn].toLowerCase() : "";
    //     if (nameA != "" && nameB != "") {
    //         if (clientSideSorting.sortOrder === 'asc') {
    //             return nameA.localeCompare(nameB);
    //         }
    //         else {
    //             return nameB.localeCompare(nameA);
    //         }
    //     }
    // });
    const indexOfLastItem = currentPage * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const currentItems = sortData(filteredData, clientSideSorting.sortOrder, clientSideSorting.sortColumn).slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = milestoneList.length;

    const onHandlePageChange = (pageNumber: any) => {
        setCurrentPage(pageNumber);
    }

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        let arr: string[] = [...clientSideSorting.columnList];
        if (!arr.includes(sortColumn)) {
            arr.push(sortColumn);
        }
        setClientSideSorting({
            ...clientSideSorting,
            sortOrder: sortOrder,
            sortColumn: sortColumn,
            columnList: arr
        });
        // setPageSize(10);
        setCurrentPage(1);
        setPageSize(pageSize);
    }

    const onHandleChangeStatus = (e: any, id: any) => {
        const { checked } = e.target;
        let Object = { 'IsDisabled': (checked ? true : false), 'AccountProjectMilestoneId': id }
        dispatch(updateIsLoading(true));
        dispatch(updateAccountProjectMilestoneStatus(Object)).then((result) => {
            Number(result.payload.Id) > 0 ?
                ShowToast('Success', result.payload.ResponseMessage, "success", "toast-top-right") :
                ShowToast('Error', result.payload.ResponseMessage, "error", "toast-top-right");
        }).catch((error) => {
        })
    }

    const deleteAccountProjectMilestoneById = (id: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(updateIsLoading(true));
                    dispatch(deleteAccountProjectMilestone(id)).then((result) => {
                        result.payload.StatusCode == "200" ?
                            ShowToast('Success', result.payload.ResponseMessage, "success", "toast-top-right") :
                            ShowToast('Error', 'Milestone Delete Failed!', "error", "toast-top-right");
                    })
                        .catch((error) => {
                        })
                }
            })
            .catch((error) => {
            });
    }

    // const handleMouseEnter = (columnIndex: any) => {
    //     setHoveredColumn(columnIndex);
    // }

    // const handleMouseLeave = () => {
    //     setHoveredColumn(null);
    // }

    return (
        <>
            {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white">
                    <h3 className="card-title fw-bold headerTitle">
                        {/* {t('Milestone List')} */}
                        {getValueFromResource('Milestone List',dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={onHandleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0 searchIconRight">
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                            {/* <Select
                                styles={paginationStyles}
                                maxMenuHeight={maxMenuHeight}
                                options={getPageSizeArray()}
                                value={getPageSizeArray().find((option: any) => option.value == pageSize)}
                                onChange={onHandlePageSizeChange}
                                className='fs-7 fw-normal'
                            /> */}
                            <PageSizeSelect onChange={onHandlePageSizeChange} />
                        </div>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(milestoneList.length > 0) ? (
                                <CustomPagination
                                    currentPage={currentPage}
                                    onPageChange={onHandlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(currentPage - 1) * pageSize}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div>
                    </div>
                </div>
                {/* <div className='card-body py-3'> */}
                <div className='card-Report-body py-3'>
                    <div className='table-responsive'>
                        <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                            <thead>
                                <tr className='thHeading align-middle'>
                                    <th style={{ width: '15%' }}
                                    // onMouseEnter={() => handleMouseEnter(0)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Active / Inactive")} */}
                                        {getValueFromResource('Active / Inactive',dispatch, t)}
                                        {clientSideSorting.sortColumn === 'IsDisabled' ?
                                            clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 0 &&
                                            <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '30%' }}
                                    // onMouseEnter={() => handleMouseEnter(1)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Milestone Name")} */}
                                        {getValueFromResource('Milestone Name',dispatch, t)}
                                        {clientSideSorting.sortColumn === 'MilestoneDescription' ?
                                            clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "MilestoneDescription") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "MilestoneDescription") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 1 && 
                                            <><span className='cursor' onClick={() => { onHandleClientSideSorting("asc", "MilestoneDescription") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className='cursor' onClick={() => { onHandleClientSideSorting("desc", "MilestoneDescription") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '15%' }}
                                    //onMouseEnter={() => handleMouseEnter(2)}
                                    //onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Start Date")} */}
                                        {getValueFromResource('Start Date',dispatch, t)}
                                        {clientSideSorting.sortColumn === 'StartDate' ?
                                            clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "StartDate") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "StartDate") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 2 && 
                                            <><span className='cursor' onClick={() => { onHandleClientSideSorting("asc", "StartDate") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className='cursor' onClick={() => { onHandleClientSideSorting("desc", "StartDate") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '15%' }}
                                    // onMouseEnter={() => handleMouseEnter(3)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Due Date")} */}
                                        {getValueFromResource('Due Date',dispatch, t)}
                                        {clientSideSorting.sortColumn === 'MilestoneDate' ?
                                            clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "MilestoneDate") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "MilestoneDate") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 3 && 
                                            <><span className='cursor' onClick={() => { onHandleClientSideSorting("asc", "MilestoneDate") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className='cursor' onClick={() => { onHandleClientSideSorting("desc", "MilestoneDate") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '15%' }}
                                    // onMouseEnter={() => handleMouseEnter(4)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Status")} */}
                                        {getValueFromResource('Status',dispatch, t)}
                                        {clientSideSorting.sortColumn === 'MilestoneStatus' ?
                                            clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "MilestoneStatus") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "MilestoneStatus") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 4 && 
                                            <><span className='cursor' onClick={() => { onHandleClientSideSorting("asc", "MilestoneStatus") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className='cursor' onClick={() => { onHandleClientSideSorting("desc", "MilestoneStatus") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.length > 0 && currentItems.map((item: any) => {
                                    return (
                                        <tr key={item.AccountProjectMilestoneId}>
                                            <td>
                                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(item.IsDisabled === 'No' ? "Active" : "InActive"))}>
                                                    {item.IsDisabled === 'No' ? "Active" : "InActive"}
                                                </span>
                                            </td>
                                            <td>
                                                <a
                                                    className='text-dark fw-bold d-block cursor'
                                                    id={IsEditMilestone ? "kt_OffCanvas" : ''}
                                                    onClick={() => {
                                                        {
                                                            dispatch(updateIsCanvasFrom('Milestone'));
                                                            IsEditMilestone && dispatch(updateMilestone({
                                                                "accountProjectMilestoneId": item.AccountProjectMilestoneId,
                                                                "isCanvasFromMilestone": true
                                                            }))
                                                        }
                                                    }}
                                                >
                                                    {item.MilestoneDescription}
                                                </a>
                                            </td>
                                            <td>
                                                <a className='text-dark d-block'>
                                                    {/* {`${moment.parseZone(item.StartDate).format('DD MMM yy')}`} */}
                                                    {formatDateWithDateAndMonthName(item.StartDate, cultureInfoName.toString())}
                                                </a>
                                            </td>
                                            <td>
                                                <a className='text-dark d-block'>
                                                    {/* {`${moment.parseZone(item.MilestoneDate).format('DD MMM yy')}`} */}
                                                    {formatDateWithDateAndMonthName(item.MilestoneDate, cultureInfoName.toString())}
                                                </a>
                                            </td>
                                            <td>
                                                <span className={`badge fs-7 ${setMilestoneStatus(item.MilestoneDate, item.Completed)?.class}`}>
                                                    {setMilestoneStatus(item.MilestoneDate, item.Completed)?.text}
                                                </span>
                                            </td>
                                            <td className='text-center'>
                                                {/* <div className="form-check form-switch form-check-custom"> */}
                                                {/* <input
                                                        type="checkbox"
                                                        className="form-check-input custom-padding-right h-15px w-30px"
                                                        checked={item.IsDisabled == "Yes" ? true : false}
                                                        onChange={(e) => { onHandleChangeStatus(e, item.AccountProjectMilestoneId) }}
                                                    /> */}
                                                {/* </div> */}


                                            </td>
                                            <td className='text-center'>
                                                <Dropdown
                                                    style={{ marginLeft: 1 }}
                                                    className={clsx('cursor-pointer symbol')}
                                                    data-kt-menu-attach='parent'
                                                    data-kt-menu-placement='bottom-end'
                                                >
                                                    <Dropdown.Toggle
                                                        variant="transparent"
                                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                        data-tooltip-id="tooltip-Description"
                                                        data-tooltip-content=
                                                        // {t("More")}
                                                        {getValueFromResource('More',dispatch, t)}
                                                        data-tooltip-place="top"
                                                    >
                                                        <i className="bi bi-three-dots fs-7"></i>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                        {IsEditMilestone &&
                                                            <><div className='menu-hover-bg-sec'>
                                                                <Dropdown.Item
                                                                    id="kt_OffCanvas"
                                                                    className="menu-item me-lg-0"
                                                                    onClick={() => {
                                                                        dispatch(updateIsCanvasFrom(getValueFromResource('Milestone', dispatch,t)));
                                                                        dispatch(updateMilestone({
                                                                            "accountProjectMilestoneId": item.AccountProjectMilestoneId,
                                                                            "isCanvasFromMilestone": true
                                                                        }))
                                                                    }}
                                                                >
                                                                    <span className="menu-icon custom-menu mb-2">
                                                                        <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title custom-menu-fontsize">
                                                                        {/* {`${t('Edit')}`} */}
                                                                        {getValueFromResource('Edit',dispatch, t)}
                                                                        </span>
                                                                </Dropdown.Item>
                                                            </div>
                                                                <div className='separator mb-1 mt-1 opacity-75'></div>
                                                            </>}
                                                        {IsDeleteMilestone
                                                            && <div className='menu-hover-bg-danger'>
                                                                <Dropdown.Item
                                                                    className="menu-item me-lg-0"
                                                                    onClick={() => { deleteAccountProjectMilestoneById(item.AccountProjectMilestoneId) }}
                                                                >
                                                                    <span className="menu-icon custom-menu mb-2">
                                                                        <i className="bi bi-trash fs-6 delete-menu-icon-color allign">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title delete-menu custom-menu-fontsize">
                                                                        {/* {`${t('Delete')}`} */}
                                                                        {getValueFromResource('Delete',dispatch, t)}
                                                                        </span>
                                                                </Dropdown.Item>
                                                            </div>}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                        {currentItems.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t('No Record Found')} */}
                                    {getValueFromResource('No Record Found',dispatch, t)}
                                    </p>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
export default MilestoneList